"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeIds = exports.buildTreeFromFilteredItems = exports.findItemsByQuery = exports.getNodePath = exports.findTreeItemById = exports.getTreeData = exports.getNodesWithChildren = exports.getTerminalNodes = void 0;
const getTerminalNodes = (nodes) => {
    const nodesWithoutChildren = [];
    const findNodesWithoutChildren = (nodes) => {
        const nodeValues = [...nodes.values()];
        nodeValues.forEach((node) => {
            if (node.children.size) {
                findNodesWithoutChildren(node.children);
            }
            else {
                nodesWithoutChildren.push(node.id);
            }
        });
    };
    findNodesWithoutChildren(nodes);
    return nodesWithoutChildren;
};
exports.getTerminalNodes = getTerminalNodes;
const getNodesWithChildren = (nodes = new Map()) => {
    const nodesWithChildren = [];
    const findNodesWithChildren = (node) => {
        if (node.children.size) {
            nodesWithChildren.push(node.id);
            for (const [_, childNode] of node.children) {
                findNodesWithChildren(childNode);
            }
        }
    };
    for (const [_, node] of nodes) {
        findNodesWithChildren(node);
    }
    return nodesWithChildren;
};
exports.getNodesWithChildren = getNodesWithChildren;
const getTreeData = (items, getTitle) => {
    const data = new Map();
    if (items && items.length > 0) {
        const map = new Map(items.map((item) => [
            item.id,
            Object.assign(Object.assign({}, item), { title: getTitle(item), children: new Map() }),
        ]));
        items.forEach((item) => {
            var _a;
            if (item.parentId) {
                (_a = map.get(item.parentId)) === null || _a === void 0 ? void 0 : _a.children.set(item.id, map.get(item.id));
            }
            else {
                data.set(item.id, map.get(item.id));
            }
        });
    }
    return data;
};
exports.getTreeData = getTreeData;
const findTreeItemById = (nodes, id) => {
    if (nodes.get(id))
        return nodes.get(id);
    let result;
    const nodeValues = [...nodes.values()];
    for (let i = 0; i < nodeValues.length; i++) {
        const node = nodeValues[i];
        if (node.children) {
            result = (0, exports.findTreeItemById)(node.children, id);
            if (result)
                break;
        }
    }
    return result;
};
exports.findTreeItemById = findTreeItemById;
const getNodePath = (nodes, node) => {
    const path = [node];
    const getNodeParent = (currentNode = node) => {
        const parent = (0, exports.findTreeItemById)(nodes, currentNode.parentId);
        if (parent) {
            path.push(Object.assign(Object.assign({}, parent), { children: new Map() }));
            getNodeParent(parent);
        }
    };
    getNodeParent();
    return path.reverse();
};
exports.getNodePath = getNodePath;
const findItemsByQuery = (nodes, query) => {
    const result = new Map();
    const findTreeNode = (nodes) => {
        const nodeValues = [...nodes.values()];
        nodeValues.forEach((node) => {
            if (node.title.match(new RegExp(query, 'i'))) {
                result.set(node.id, node);
            }
            if (node.children.size) {
                findTreeNode(node.children);
            }
        });
    };
    findTreeNode(nodes);
    return result;
};
exports.findItemsByQuery = findItemsByQuery;
const buildTreeFromFilteredItems = (nodes, query) => {
    if (!query)
        return nodes;
    const result = (0, exports.findItemsByQuery)(nodes, query);
    const parentNodes = new Map();
    const setNodeToParent = (node) => {
        const parent = (0, exports.findTreeItemById)(parentNodes, node.parentId);
        if (parent && !parent.children.has(node.id)) {
            parent.children.set(node.id, Object.assign(Object.assign({}, node), { children: new Map() }));
        }
    };
    [...result.values()].forEach((node) => {
        const path = (0, exports.getNodePath)(nodes, node);
        for (let i = 0; i < path.length; i++) {
            const rootNode = 0;
            const item = path[i];
            if (i === rootNode) {
                if (!parentNodes.has(item.id)) {
                    parentNodes.set(item.id, Object.assign(Object.assign({}, item), { children: new Map() }));
                }
            }
            else {
                setNodeToParent(item);
            }
        }
    });
    return parentNodes;
};
exports.buildTreeFromFilteredItems = buildTreeFromFilteredItems;
const getNodeIds = (nodes) => {
    const result = [];
    function getNode(nodes) {
        nodes.forEach((node) => {
            result.push(node.id);
            if (node.children.size) {
                getNode(node.children);
            }
        });
    }
    getNode(nodes);
    return result;
};
exports.getNodeIds = getNodeIds;
